module.exports = __webpack_public_path__ + "static/media/dashboardMarge_fr.3cffe344.png";